<template>
  <div class="autoitem"  @mouseover="onpic()" @mouseout="pic()" :class="{onshow:alive,lastitem:index==3}">
      <div class="autoitemtop">
        <img v-if="alive" :src="auto.pic">
         <img v-else :src="auto.onpic">
        <div>
          {{auto.title}}
        </div>
      </div>
      <p>
        {{auto.des}}
      </p>
  </div>
</template>

<script>
export default {
  data(){
    return{
      alive:false
    }
  },
  props:['auto','index'],
  methods:{
    onpic:function(){
      this.alive=true
    },
    pic:function(){
      this.alive=false
    }
  }
}
</script>

<style scoped>
  .autoitem{
    width: 268px;
    border: 1px solid #dddddd;
    color: #666666;
    border-radius: 10px;
    float: left;
    margin-right: 40px;
  }
  .lastitem{
    margin-right: 0;
  }
  .autoitem .autoitemtop{
    width: 237px;
    margin: 0 auto;
    border-bottom:  1px solid #dddddd;
    text-align: center;
    margin-top: 25px;
   
  
  }
  .autoitem .autoitemtop img{
    width: 102px;
    height: 102px;
  }
  .autoitem .autoitemtop div{
    margin-top: 28px;
    margin-bottom: 12px;
    font-weight: 700;
    font-size: 20px;
    color: #333;
  }
  .autoitem:hover .autoitemtop div{
    color: #fff;
  }
  .autoitem p{
    font-family: Helvetica Neue,Helvetica,PingFang SC,\5FAE\8F6F\96C5\9ED1,Tahoma,Arial,sans-serif;
    color: #000;
    font-size: 14px;
    line-height: 2;
    text-align: center;
    
    
    width: 208px;
    margin: 0 auto;
    margin-top: 15px;
    height: 77px;
    overflow: hidden;
    margin-bottom: 20px;
  }
  .autoitem:hover p{
    color:#fff;
  }
  .onshow{
    color: #fff;
    border: 1px solid #2655ae;
    background-color: #2655ae;
  }
</style>


// WEBPACK FOOTER //
// src/components/index/GoodsAutomationItem.vue